import * as S from './TableTitle.styles';

type TableTitleProps = {
  children: React.ReactNode;
  className?: string;
};

export function TableTitle(props: TableTitleProps): React.ReactElement {
  const { children, className } = { ...props };

  return (
    <S.Title
      className={className}
      tag="h2"
      scale="xl"
      fontWeight="normal"
      textTransform="uppercase"
    >
      {children}
    </S.Title>
  );
}
